export default __webpack_public_path__ + "static/media/store.1d48201b.svg";